import {AUTO_MODEL_ID} from '@github-ui/copilot-chat-helpers/auto-model'
import {type AutoTier, getAutoTierForModel} from '@github-ui/copilot-chat-helpers/auto-tiers'
import {copilotLocalStorage} from '@github-ui/copilot-chat-helpers/copilot-local-storage'
import type {Dispatcher} from '@github-ui/copilot-chat-state/copilot-chat-reducer'
import type {CopilotChatModel} from '@github-ui/copilot-chat-types'
import {copilotFeatureFlags} from '@github-ui/copilot-feature-flags'

export function persistAutoTierForSentModel(
  threadID: string,
  model: CopilotChatModel | null | undefined,
  autoTier: AutoTier,
) {
  if (copilotFeatureFlags.autoModeV2 && model?.id === AUTO_MODEL_ID) {
    copilotLocalStorage.setAutoTier(threadID, autoTier, false)
  }
}

export function updateAutoTierSelection(
  dispatch: Dispatcher,
  threadID: string | null,
  autoTier: AutoTier,
  updateLocalStorage: boolean,
  updateDefault: boolean,
) {
  dispatch({type: 'SELECT_AUTO_TIER', autoTier})
  if (updateLocalStorage) {
    copilotLocalStorage.setAutoTier(threadID, autoTier, updateDefault)
  }
}

export function getAutoTierForRequest(modelID: string | undefined, autoTier: AutoTier) {
  return copilotFeatureFlags.autoModeV2 ? getAutoTierForModel(modelID, autoTier) : undefined
}
